var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chat-container"}},[_c('h2',{attrs:{"id":"logo"}},[_vm._v("Sandesha")]),_c('menu-comp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }